import 'swiped-events';

( function( $ ) {
    $(function(){
        const $masoneryGrid = $(".ms-gallery");
        
        if($masoneryGrid.length) {

            $masoneryGrid.imagesLoaded().progress( function() {
                $masoneryGrid.masonry({
                    itemSelector: '.ms-gallery-item',
                    columnWidth: '.ms-gallery-sizer',
                    gutter: '.ms-gallery-gutter',
                    percentPosition: true,
                });
            });

            lightbox.option({
                hasVideo: true,
                positionFromTop: 0,
                alwaysShowNavOnTouchDevices: true,
                disableScrolling: true,
                showImageNumberLabel: false,
            });

            $(function() {
                const $closeContainer = $('.lb-closeContainer');
                $closeContainer.clone(true).prepend("<div class='lb-logo'>"+ $(".site-title a").html()+"</div>").prependTo("#lightbox");
                $closeContainer.remove();
                // Re-position next prev icons
                const $prevIcon = $('.lb-nav .lb-prev').clone(true).prependTo('#lightbox');
                const $nextIcon = $('.lb-nav .lb-next').clone(true).appendTo('#lightbox');
                $('.lb-nav').remove();
            });

            $(document).on('swiped', '.lightbox', function(e) {
                if(e.detail.dir === 'left') {
                    if (lightbox.currentImageIndex === lightbox.album.length - 1) {
                        lightbox.changeImage(0);
                    } else {
                        lightbox.changeImage(lightbox.currentImageIndex + 1);
                    }
                }

                if(e.detail.dir === 'right') {
                    if (lightbox.currentImageIndex === 0) {
                        lightbox.changeImage(lightbox.album.length - 1);
                    } else {
                        lightbox.changeImage(lightbox.currentImageIndex - 1);
                    }
                }
            });
        }
    });
}( jQuery ) );